<div class="py-3 ">
  <div class="row row-xs">
    <div class="col-lg-8 col-md-12 col-sm-12">
      <div class="card">
        <div class="card-body p-2">
          <div class="w-100 bg-white px-2">
            <h1 class="card-title mb-0 d-flex align-items-center">
              <span class="lstick"></span>
              <a href="javascript:void(0);" routerLink="/blog"><span class="mdi mdi-arrow-left mdi-24px pos-rel-1"></span></a>
              <span>All Articles</span>
            </h1>
          </div>
        </div>
      </div>
      <div class="card" *ngIf="blogDetailsLoader">
        <div class="card-body text-center">
          <h5 class="mt-0 d-flex align-items-start w-75">
            <span class="flex-fill animated-background-name first-loader-name-news m-0">
              <div class="background-masker btn-divide-left"></div>
            </span>
          </h5>
          <h5 class="mt-0 d-flex align-items-start w-25">
            <span class="flex-fill animated-background-name first-loader-name-news m-0">
              <div class="background-masker btn-divide-left"></div>
            </span>
          </h5>
          <h5 class="mt-0 d-flex align-items-start w-50">
            <span class="flex-fill animated-background-name first-loader-name-news m-0">
              <div class="background-masker btn-divide-left"></div>
            </span>
          </h5>
          <h5 class="mt-0 d-flex align-items-start w-50">
            <span class="flex-fill animated-background-name first-loader-name-news m-0">
              <div class="background-masker btn-divide-left"></div>
            </span>
          </h5>
          <div class="animated-background first-loader-ad" style="height: 180px;">
            <div class="background-masker btn-divide-left"></div>
          </div>
          <h5 class="mt-0 d-flex align-items-start my-4">
            <span class="flex-fill animated-background-name first-loader-name-news m-0">
              <div class="background-masker btn-divide-left"></div>
            </span>
          </h5>
          <h5 class="mt-0 d-flex align-items-start">
            <span class="flex-fill animated-background-name first-loader-name-news m-0">
              <div class="background-masker btn-divide-left"></div>
            </span>
          </h5>
          <h5 class="mt-0 d-flex align-items-start">
            <span class="flex-fill animated-background-name first-loader-name-news m-0">
              <div class="background-masker btn-divide-left"></div>
            </span>
          </h5>
          <h5 class="mt-0 d-flex align-items-start w-75">
            <span class="flex-fill animated-background-name first-loader-name-news m-0">
              <div class="background-masker btn-divide-left"></div>
            </span>
          </h5>
          <h5 class="mt-0 d-flex align-items-start my-4">
            <span class="flex-fill animated-background-name first-loader-name-news ml-0 mr-4">
              <div class="background-masker btn-divide-left"></div>
            </span>
            <span class="shared-dom">
              <div class="sub-rect-news pure-background"></div>
            </span>
          </h5>
        
        </div>
       
      </div>
      <div class="card" *ngIf="emptyBlogDetails">
        <div class="card-body ">
          <h4 class="m-2 text-center">No blog available here!</h4>
        </div>
      </div>
      <div>
        <div class="card" *ngIf="!blogDetailsLoader && !emptyBlogDetails">
          <div class="card-body">
            <div class="w-100">
              <div class="blogHeading">
                <h1 class="card-title mb-0">{{blogDetailsArr.blog_title}}</h1>
              </div>
              <h2 class="mb-1 fs-18 text-info">
                <span class="blog-cat">Category</span> - <span class="blog-cat-name" (click)="filterByCategory(blogDetailsArr.category_id,blogDetailsArr.category_name)">{{blogDetailsArr.category_name}}</span>
              </h2>
              <p class="mb-2 font-bold d-inline-block">
                Posted on {{blogDetailsArr.posted_time}} By
                <a href="javascript:void(0);">{{blogDetailsArr.name}}</a>
              </p>
              <div class="float-right">
                <div class="btn-group" dropdown placement="bottom right">
                  <a href="javascript:void(0);" dropdownToggle class="dropdown-toggle margin share_hover" aria-controls="dropdown-basic" ngbTooltip="Share Blog on your timeline / with fans / on message chat" tooltipClass="mytooltip" *ngIf="!controlsMob">
                    <img  src="{{share_icon}}" class="img-fluid" alt="..." width="35">
                  </a>
                  <a href="javascript:void(0);" dropdownToggle class="dropdown-toggle margin share_hover" aria-controls="dropdown-basic" *ngIf="controlsMob">
                    <img    src="{{share_icon}}" class="img-fluid" alt="..." width="35">
                  </a>
                  <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="button-basic">
                    <li class="light-blue" role="menuitem">
                      <div (click)="openModal(share, blogDetailsArr);">
                        <a class="dropdown-item" href="javascript:void(0);">Share on my
                          timeline</a>
                        <a href="javascript:void(0);"><small class="d-block mx-2 mb-2">Share on your own connections
                            timeline</small></a>
                      </div>
                      <div class="dropdown-divider"></div>
                    </li>
                    <li class="light-blue" role="menuitem">
                      <div (click)="openModal(shareFriendTimeLine, blogDetailsArr);openModalMessengerFriend();">
                        <a class="dropdown-item" href="javascript:void(0);">Share on a
                          Connections timeline</a>
                        <a href="javascript:void(0);"><small class="d-block mx-2 mb-2">Share on your connected connections
                            timeline</small></a>
                      </div>
                      <div class="dropdown-divider"></div>
                    </li>
                    
                    <li class="light-blue" role="menuitem">
                      <div (click)="openModal(shareMessenger, blogDetailsArr);openModalMessenger();">
                        <a class="dropdown-item" href="javascript:void(0);">Send in
                          messenger</a>
                        <a href="javascript:void(0);">
                          <small class="d-block mx-2">Share with your fans/connections in message
                            chat</small>
                        </a>
                      </div>
                      <div class="dropdown-divider"></div>
                    </li>
                    <li class="light-blue" role="menuitem">
                      <div (click)="postUrlCopy(blogDetailsArr);">
                        <a class="dropdown-item" href="javascript:void(0);">Copy Link To Blog</a>
                        <a href="javascript:void(0);"><small class="d-block mx-2 mb-2">Click here to copy blog
                            link</small></a>
                      </div>
                    </li>
                    
                  </ul>
                </div>
              </div>
              <div class="post-thumb mb-2">
                <div *ngIf="blogDetailsArr.blog_media && blogDetailsArr.blog_media.length>0">
                  <span *ngIf="blogDetailsArr.blog_media && blogDetailsArr.blog_media[0].media_mime_type.includes('image/')">
                    <img    src="{{blogDetailsArr.blog_media[0].media_path}}" class="img-fluid" alt="Blog" />
                  </span>
                </div>
              </div>
              <div class="post-thumb mb-2">
                <div *ngIf="blogDetailsArr.blog_media && blogDetailsArr.blog_media.length>0">
                  <span *ngIf="blogDetailsArr.blog_media && blogDetailsArr.blog_media[0].media_mime_type.includes('video/')">
                    <video *ngIf="blogDetailsArr.blog_media[0].thumb_media_path && blogDetailsArr.blog_media[0].thumb_media_path !=''" poster="{{blogDetailsArr.blog_media[0].thumb_media_path}}" [muted]="true" src="{{blogDetailsArr.blog_media[0].media_path}}" preload="metadata" controls="controls" class="video-fluid" alt="Blog" loop (mouseout)='pauseVideo($event)' type="video/mp4" controlsList="nodownload">

                      <track label="English" kind="captions" srclang="en" src="" default>
                    </video>
                    <video *ngIf="blogDetailsArr.blog_media[0].thumb_media_path =='' || blogDetailsArr.blog_media[0].thumb_media_path==null" [muted]="true" src="{{blogDetailsArr.blog_media[0].media_path}}" preload="metadata" controls="controls" class="video-fluid" alt="Blog" loop (mouseout)='pauseVideo($event)' type="video/mp4" controlsList="nodownload">

                      <track label="English" kind="captions" srclang="en" src="" default>
                    </video>
                  </span>
                </div>
              </div>
            
              <div [innerHTML]='blogDetailsArr.blog_content'></div>
              <hr>
              <div class="float-right">
                <!-- <div class="btn-group" dropdown placement="bottom right" [dropup]="isDropup"> -->
                <div class="btn-group" dropdown placement="bottom right">
                  <a href="javascript:void(0);" dropdownToggle class="dropdown-toggle share_hover" aria-controls="dropdown-dropup" placement="top" ngbTooltip="Share Blog on your timeline / with fans / on message chat" tooltipClass="mytooltip" *ngIf="!controlsMob">
                    <img    src="{{share_icon}}" class="img-fluid" alt="..." width="35">
                  </a>
                  <a href="javascript:void(0);" dropdownToggle class="dropdown-toggle share_hover" aria-controls="dropdown-dropup" placement="top" *ngIf="controlsMob">
                    <img    src="{{share_icon}}" class="img-fluid" alt="..." width="35">
                  </a>
                  <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right dropup-cus" role="menu" aria-labelledby="button-basic">
                    <li class="light-blue" role="menuitem">
                      <div (click)="openModal(share, blogDetailsArr);">
                        <a class="dropdown-item" href="javascript:void(0);">Share on my
                          timeline</a>
                        <a href="javascript:void(0);"><small class="d-block mx-2 mb-2">Share on your own connections
                            timeline</small></a>
                      </div>
                      <div class="dropdown-divider"></div>
                    </li>
                    <li class="light-blue" role="menuitem">
                      <div (click)="openModal(shareFriendTimeLine, blogDetailsArr);openModalMessengerFriend();">
                        <a class="dropdown-item" href="javascript:void(0);">Share on a
                          Connections timeline</a>
                        <a href="javascript:void(0);"><small class="d-block mx-2 mb-2">Share on your connected connections
                            timeline</small></a>
                      </div>
                      <div class="dropdown-divider"></div>
                    </li>
                    
                    <li class="light-blue" role="menuitem">
                      <div (click)="openModal(shareMessenger, blogDetailsArr);openModalMessenger();">
                        <a class="dropdown-item" href="javascript:void(0);">Send in
                          messenger</a>
                        <a href="javascript:void(0);">
                          <small class="d-block mx-2">Share with your fans/connections in message
                            chat</small>
                        </a>
                      </div>
                      <div class="dropdown-divider"></div>
                    </li>
                    <li class="light-blue" role="menuitem">
                      <div (click)="postUrlCopy(blogDetailsArr);">
                        <a class="dropdown-item" href="javascript:void(0);">Copy Link To Blog</a>
                        <a href="javascript:void(0);"><small class="d-block mx-2 mb-2">Click here to copy blog
                            link</small></a>
                      </div>
                    </li>
                  
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="col-lg-4 col-md-12 col-sm-12">
      <div class="card">
        <div class="card-header bg-dark-blue rounded-top fs-14">
          Most Popular Articles
        </div>
        <div class="card-body">
         
          <div class="comment-widgets mb-0">
            <ul class="list-unstyled seperater mb-0" *ngIf="!mostViewedBlogLoader">
              <li class="text-info cursor-pointer" *ngFor="let blogdetails of mostViewedBlogArr" (click)="goToBlog(blogdetails.blog_title_url);">
                <a class="text-dark" href="{{blogdetails.blog_link}}">{{blogdetails.blog_title}}</a>
              </li>
            </ul>
            <div *ngIf="mostViewedBlogLoader">
              <h5 class="mt-0 d-flex align-items-start">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div class="sticky">
        <div class="card">
          <div class="card-header bg-dark-blue rounded-top fs-14">
            Categories
          </div>
          <div class="card-body">
            <ul class="list-unstyled seperater mb-0" *ngIf="!categoryLoader">
              <li class="text-info" *ngFor="let category of categoryList">
                <a href="javascript:void(0);" (click)="filterByCategory(category.id)">
                  <div class="d-flex py-1">
                    {{category.category_name}} <strong *ngIf="category.category_count > 0" class='ml-1'>({{category.category_count}})</strong>
                  </div>
                </a>
              </li>
            </ul>
            <div *ngIf="categoryLoader">
              <h5 class="mt-0 d-flex align-items-start">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #share>
  <div class="modal-header modal-header-new">
    <h4 class="modal-title pull-left">Share Post</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body modal-body-new">
    <div class="media">
      <div class="media-body">
        <div class="form-group">

          <div class="bg-light py-1 mb-2 row">
            <div class="col-10">
              <span class="text-muted mb-0" *ngIf="sharePostArr.sharePostTextShow != ''">
                <span [innerHtml]="sharePostArr.sharePostTextShow"></span>
              </span>
              <p class="text-muted mb-0" *ngIf="sharePostArr.sharePostDescriptionShow != ''" [innerHtml]="sharePostArr.sharePostDescriptionShow">
              </p>
            </div>
            <div class="col-2" *ngIf="sharePostArr.media_path !=''">
              <div class="postImg border">
                <img alt="loading..."    *ngIf="sharePostArr.media_mime_type.includes('image/')" src="{{sharePostArr.media_path}}" class="img-fluid">
                <video *ngIf="sharePostArr.media_mime_type.includes('video/')" [muted]="true" id="videoId" src="{{sharePostArr.media_path}}" class="video-fluid img-res-popup" volume preload="metadata" type="video/mp4" controlsList="nodownload">
                  <track label="English" kind="captions" srclang="en" src="" default>
                </video>
              </div>
            </div>
          </div>

         
          <div class="row">
            <div class="col-2">
              <span class="nav-item dropdown" ngbDropdown #privacyDrop="ngbDropdown" placement="bottom-right">
                <i *ngIf="user_details.profile_type != 0" class="mdi {{addPostArr.iconClassnName}}"></i>
                <a ngbDropdownToggle class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="javascript:void(0)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" *ngIf="user_details.profile_type == 0">
                  <i class="mdi {{addPostArr.iconClassnName}}"></i>
                </a>
                <div class="custom-dropdown dropdown-menu dropdown-menu-new animated fadeIn" ngbDropdownMenu>
                  <ul class="dropdown-privacy">
                    <li *ngFor="let pst of PostSendType">
                      <span *ngIf="platform_id==1">
                        <a class="dropdown-item" href="javascript:void(0);" (click)="SetPrivacySettingsBtn(pst.id,pst.icon_class_name);">
                          <div class="d-flex">
                            <i class="mdi {{pst.icon_class_name}} mdi-18px pr-2"></i>
                            {{pst.privacy_type}}
                          </div>
                          <small class="d-block ml-4 text-left privacy-desc-line-height">{{pst.privacy_type_explanation}}</small>
                        </a>
                      </span>
                      <span *ngIf="platform_id==2">
                        <a class="dropdown-item" href="javascript:void(0);" (click)="SetPrivacySettingsBtn(pst.id,pst.icon_class_name);">
                          <div class="d-flex">
                            <i class="mdi {{pst.icon_class_name}} mdi-18px pr-2"></i>
                            {{pst.progressive_privacy_type}}
                          </div>
                          <small class="d-block ml-4">{{pst.progressive_privacy_type_explanation}}</small>
                        </a>
                      </span>
                    </li>
                  </ul>
                </div>
              </span>
            </div>
            <div class="col-12">
              <textarea name="sharePostText" [maxlength]="totalMaxLength" (input)="urlifyPostOnlyLink($event)" [(ngModel)]="sharePostArr.sharePostText" #sharePostText="ngModel" rows="3" class="form-control news-textarea" placeholder="Write Something Here..."></textarea>
            </div>
          </div>


        </div>

        <div class="d-flex justify-content-between align-items-center border-top border-light pt-2">
          <div class="send-btn">
            <a *ngIf="showHideSharePost && totalStringLength < 2001" href="javascript:void(0);" (click)="CreatePostBtn(); modalRef.hide()" class="btn btn-sm btn-post-new" placement="top">
              <span class="mdi mdi-send"></span> Post</a>

            <span *ngIf="!showHideSharePost || totalStringLength > 2000 && postButtonHide">
              <a href="javascript:void(0);" class="btn btn-sm btn-post-new" placement="top">
                <span class="mdi mdi-send"></span> Post</a></span>
            <span *ngIf="totalStringLength > 2000" class="text-danger ml-3 fs-12">
              You cannot enter more than 2000 characters.</span>

          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!--Share on Messenger Modal(a) -->
<ng-template #shareMessenger>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Send in Messenger</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="media">
      <div class="media-body">

        <!-- Share Post Text here(n) -->

        <div class="bg-light py-1 mb-2 row">
          <div class="col-10">
            <span class="text-muted mb-0" *ngIf="sharePostArr.sharePostTextShow != ''">
              <span [innerHtml]="sharePostArr.sharePostTextShow"></span>
            </span>
            <p class="text-muted mb-0" *ngIf="sharePostArr.sharePostDescriptionShow != ''" [innerHtml]="sharePostArr.sharePostDescriptionShow">
              <!-- {{sharePostArr.sharePostDescriptionShow}} -->
            </p>
          </div>
          <div class="col-2" *ngIf="sharePostArr.media_path !=''">
            <div class="postImg border">
              <img alt="loading..."    *ngIf="sharePostArr.media_mime_type.includes('image/')" src="{{sharePostArr.media_path}}" class="img-fluid">
              <video *ngIf="sharePostArr.media_mime_type.includes('video/')" [muted]="true" id="videoId" src="{{sharePostArr.media_path}}" class="video-fluid img-res-popup" volume preload="metadata" type="video/mp4" controlsList="nodownload">
                <track label="English" kind="captions" srclang="en" src="" default>
              </video>
            </div>
          </div>
        </div>

        <div *ngIf="showHideSharePostSocialMediaConservative" class="media">

          <div class="media-body">
            <div class="text-comment">
              <textarea name="sharePostTextMsg" [maxlength]="totalMaxLength" (input)="urlifyPostOnlyLink($event)" [(ngModel)]="sharePostArr.sharePostTextMsg" #sharePostTextMsg="ngModel" rows="3" class="form-control" placeholder="Write Something Here..."></textarea>
            </div>

            <span *ngIf="totalStringLength > 2000" class="text-danger ml-3 fs-12">
              You cannot enter more than 2000 characters.</span>
          </div>
        </div>
        <hr>
        <div class="search">
         

          <input type="text" name="contactSearch" [(ngModel)]="contactSearch" (keyup)="contactListSearchFunction($event)" class="form-control border mb-2" placeholder="Search">
          <span class="mdi mdi-magnify mdi-2x"></span>
        </div>

        <div class="stickyTab">
          <div class="card">
            <ul class="followTabs list-unstyled d-flex justify-content-between align-items-center mb-0">
              <li class="flex-fill" (click)="selectAllUserOrFans('2')" [ngClass]="{'f-active': user_list_section_type=='2'}">
                <a href="javascript:void(0);">Connections</a>
              </li>
              <li class="flex-fill f-active" (click)="selectAllUserOrFans('1')" [ngClass]="{'f-active': user_list_section_type=='1'}">
                <a href="javascript:void(0);">Message Requests</a>
              </li>
            </ul>
          </div>
        </div>

        <ul class="list-unstyled notMes TagTeamGroupheight" *ngIf="connectUserListArr.length > 0" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()" [scrollWindow]="false">
          <li *ngFor="let user of connectUserListArr; let key = index">
            <div class="media align-items-center">
              <img    *ngIf="user.profile_pic != ''" src="{{user.profile_pic}}" class="mr-3 img-fluid  rounded-circle" alt="..." width="40">
              <img    *ngIf="user.profile_pic == ''" src="{{user_profile_img}}" class="mr-3 img-fluid  rounded-circle" alt="..." width="40">
              <div class="media-body">
                <h5 class="mt-0">
                  <div class="d-flex align-items-center float-left">
                    <span class="text-truncate mw mt-0"> {{user.name}}</span>
                  </div>
                  <a *ngIf="!clickedBtn" href="javascript:void(0);" (click)="forwardMessageSendFun(sharePostArr,user);modalRef.hide()" class="btn btn-sm btn-info float-right">Send</a>
                  <a *ngIf="clickedBtn" href="javascript:void(0);" class="btn btn-sm btn-info float-right">Send</a>
                </h5>
              </div>
            </div>
          </li>
        </ul>

        <ul *ngIf="connectUserListArr.length == 0" class="list-unstyled notMes">

          <div class="text-center p-2" *ngIf="UserDetailsLoaderFirstTime && !chatListMobileView">
            <div *ngFor="let e of [].constructor(3)" class="d-flex align-items-center justify-content-between mt-2">
              <div>
                <h5 class="mt-0 d-flex align-items-start">
                  <span class="shared-dom">
                    <div class="sub-rect-user-list pure-background"></div>
                  </span>
                </h5>
              </div>

              <div class="w-50 ml-2">
                <h5 class="mt-0 d-flex align-items-start w-75">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
                <h5 class="mt-0 d-flex align-items-start w-50">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
                <h5 class="mt-0 d-flex align-items-start w-25">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
              </div>

              <div class="w-25">
                <h5 class="mt-0 d-flex align-items-start">
                  <span class="shared-dom mt-2 ml-3">
                    <div class="sub-rect-user-follow pure-background"></div>
                  </span>
                </h5>
              </div>
            </div>
          </div>

          <li class="text-center" *ngIf="!UserDetailsLoaderFirstTime">
            <h5>
              <strong>No Message Requests!</strong>
            </h5>
            <p>Your message requests inbox is empty.</p>
            <a class="btn btn-info btn-sm" href="javascript:void(0)" routerLink="/followGroup/suggestion">Let's Go!</a>
          </li>
        </ul>

        <div class="text-center" *ngIf="UserDetailsLoader && connectUserListArr.length > 0">
          <div *ngFor="let e of [].constructor(1)" class="d-flex align-items-center justify-content-between mt-2">
            <div>
              <h5 class="mt-0 d-flex align-items-start">
                <span class="shared-dom">
                  <div class="sub-rect-user-list pure-background"></div>
                </span>
              </h5>
            </div>

            <div class="w-50 ml-2">
              <h5 class="mt-0 d-flex align-items-start w-75">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start w-50">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start w-25">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
            </div>

            <div class="w-25">
              <h5 class="mt-0 d-flex align-items-start">
                <span class="shared-dom mt-2 ml-3">
                  <div class="sub-rect-user-follow pure-background"></div>
                </span>
              </h5>
            </div>

          </div>
        </div>

        

        <div class="text-center position-relative" *ngIf="showMoreUserConnectList">
          <a href="javascript:void(0);" (click)="showMoreUserListByName(nextPageConnectUserList)" class="read-more read-more-top" placement="top">
            <span class="mdi mdi-chevron-double-down">Show More</span>
          </a>
        </div>

        
        <!-- Conservative(n) -->

      </div>
    </div>
  </div>
</ng-template>
<!--End Share on Messenger Modal(a) -->

<!--Share on Friend Timeline Modal(a) -->
<ng-template #shareFriendTimeLine>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Share on a Connections timeline</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="media">
      <div class="media-body">

        <!-- Share Post Text here(n) -->

        <div class="bg-light py-1 mb-2 row">
          <div class="col-10">
            <span class="text-muted mb-0" *ngIf="sharePostArr.sharePostTextShow != ''">
              <span [innerHtml]="sharePostArr.sharePostTextShow"></span>
            </span>
            <p class="text-muted mb-0" *ngIf="sharePostArr.sharePostDescriptionShow != ''" [innerHtml]="sharePostArr.sharePostDescriptionShow">
              <!-- {{sharePostArr.sharePostDescriptionShow}} -->
            </p>
          </div>
          <div class="col-2" *ngIf="sharePostArr.media_path !=''">
            <div class="postImg border">
              <img alt="loading..."    *ngIf="sharePostArr.media_mime_type.includes('image/')" src="{{sharePostArr.media_path}}" class="img-fluid">
              <video *ngIf="sharePostArr.media_mime_type.includes('video/')" [muted]="true" id="videoId" src="{{sharePostArr.media_path}}" class="video-fluid img-res-popup" volume preload="metadata" type="video/mp4" controlsList="nodownload">
                <track label="English" kind="captions" srclang="en" src="" default>
              </video>
            </div>
          </div>
        </div>

        <div *ngIf="showHideSharePostSocialMediaConservative" class="media">

          <div class="media-body">
            <div class="text-comment">
              <textarea name="sharePostText" [maxlength]="totalMaxLength" (input)="urlifyPostOnlyLink($event)" [(ngModel)]="sharePostArr.sharePostText" #sharePostText="ngModel" rows="3" class="form-control news-textarea" placeholder="Write Something Here..."></textarea>
            </div>

            <span *ngIf="totalStringLength > 2000" class="text-danger ml-3 fs-12">
              You cannot enter more than 2000 characters.</span>
          </div>
        </div>
        <hr>
        <div class="search">
        

          <input type="text" name="contactSearch" [(ngModel)]="contactSearch" (keyup)="contactListSearchFunction($event)" class="form-control border mb-2" placeholder="Search">
          <span class="mdi mdi-magnify mdi-2x"></span>
        </div>

        <div class="stickyTab">
          <div class="card">
            <ul class="followTabs list-unstyled d-flex justify-content-between align-items-center mb-0">
              <li class="flex-fill" (click)="selectAllUserOrFans('2')" [ngClass]="{'f-active': user_list_section_type=='2'}">
                <a href="javascript:void(0);">Connections</a>
              </li>
              <li class="flex-fill f-active" (click)="selectAllUserOrFans('1')" [ngClass]="{'f-active': user_list_section_type=='1'}">
                <a href="javascript:void(0);">Message Requests</a>
              </li>
            </ul>
          </div>
        </div>

        <ul class="list-unstyled notMes TagTeamGroupheight" *ngIf="connectUserListArr.length > 0" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="50" (scrolled)="onScroll()" [scrollWindow]="false">
          <li *ngFor="let user of connectUserListArr; let key = index">
            <div class="media align-items-center">
              <img    *ngIf="user.profile_pic != ''" src="{{user.profile_pic}}" class="mr-3 img-fluid  rounded-circle" alt="..." width="40">
              <img   *ngIf="user.profile_pic == ''" src="{{user_profile_img}}" class="mr-3 img-fluid  rounded-circle" alt="..." width="40">
              <div class="media-body">
                <h5 class="mt-0">
                  <div class="d-flex align-items-center float-left">
                    <span class="text-truncate mw mt-0"> {{user.name}}</span>
                  </div>
                  <a *ngIf="!clickedBtn && showHideSharePost" href="javascript:void(0);" (click)="CreatePostBtnFrient(sharePostArr,user);modalRef.hide()" class="btn btn-sm btn-info float-right">Send</a>
                  <a *ngIf="clickedBtn && !showHideSharePost" href="javascript:void(0);" class="btn btn-sm btn-info float-right">Send</a>
                </h5>
              </div>
            </div>
          </li>
        </ul>

        <ul *ngIf="connectUserListArr.length == 0" class="list-unstyled notMes">

          <div class="text-center p-2" *ngIf="UserDetailsLoaderFirstTime && !chatListMobileView">
            <div *ngFor="let e of [].constructor(3)" class="d-flex align-items-center justify-content-between mt-2">
              <div>
                <h5 class="mt-0 d-flex align-items-start">
                  <span class="shared-dom">
                    <div class="sub-rect-user-list pure-background"></div>
                  </span>
                </h5>
              </div>

              <div class="w-50 ml-2">
                <h5 class="mt-0 d-flex align-items-start w-75">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
                <h5 class="mt-0 d-flex align-items-start w-50">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
                <h5 class="mt-0 d-flex align-items-start w-25">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
              </div>

              <div class="w-25">
                <h5 class="mt-0 d-flex align-items-start">
                  <span class="shared-dom mt-2 ml-3">
                    <div class="sub-rect-user-follow pure-background"></div>
                  </span>
                </h5>
              </div>
            </div>
          </div>

          <li class="text-center" *ngIf="!UserDetailsLoaderFirstTime">
            <h5>
              <strong>No Message Requests!</strong>
            </h5>
            <p>Your message requests inbox is empty.</p>
            <a class="btn btn-info btn-sm" href="javascript:void(0)" routerLink="/followGroup/suggestion">Let's Go!</a>
          </li>
        </ul>

        <div class="text-center" *ngIf="UserDetailsLoader && connectUserListArr.length > 0">
          <div *ngFor="let e of [].constructor(1)" class="d-flex align-items-center justify-content-between mt-2">
            <div>
              <h5 class="mt-0 d-flex align-items-start">
                <span class="shared-dom">
                  <div class="sub-rect-user-list pure-background"></div>
                </span>
              </h5>
            </div>

            <div class="w-50 ml-2">
              <h5 class="mt-0 d-flex align-items-start w-75">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start w-50">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
              <h5 class="mt-0 d-flex align-items-start w-25">
                <span class="flex-fill animated-background-name first-loader-name-news m-0">
                  <div class="background-masker btn-divide-left"></div>
                </span>
              </h5>
            </div>

            <div class="w-25">
              <h5 class="mt-0 d-flex align-items-start">
                <span class="shared-dom mt-2 ml-3">
                  <div class="sub-rect-user-follow pure-background"></div>
                </span>
              </h5>
            </div>

          </div>
        </div>

        

        <div class="text-center position-relative" *ngIf="showMoreUserConnectList">
          <a href="javascript:void(0);" (click)="showMoreUserListByName(nextPageConnectUserList)" class="read-more read-more-top" placement="top">
            <span class="mdi mdi-chevron-double-down">Show More</span>
          </a>
        </div>
        <!-- Conservative(n) -->

      </div>
    </div>
  </div>
</ng-template>
<!--End Share on Friend Timeline Modal(a) -->

<ng-template #sports>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Share Post</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="media">
      <div class="media-body w-100">
        <div class="form-group mb-2">
          <div class="bg-light p-2 mb-2 row">
            <div class="col-10">
              <span class="text-muted mb-0 truncate_bio" *ngIf="sharePostArr.sharePostText != ''">
                <span class="text-break" [innerHtml]="sharePostArr.sharePostTextShow"></span>
              </span>
              <p class="text-muted mb-0 truncate_bio" *ngIf="sharePostArr.sharePostDescriptionShow != ''">
                {{sharePostArr.sharePostDescriptionShow}}
              </p>
            </div>
            <div class="col-2" *ngIf="sharePostArr.media_path !=''">
              <div class="postImg border">
                <img alt="loading..."    *ngIf="sharePostArr.media_mime_type.includes('image/')" src="{{sharePostArr.media_path}}" class="img-fluid">
                <video *ngIf="sharePostArr.media_mime_type.includes('video/')" [muted]="true" id="videoId" src="{{sharePostArr.media_path}}" class="video-fluid img-res-popup" volume preload="metadata" type="video/mp4" controlsList="nodownload">
                  <track label="English" kind="captions" srclang="en" src="" default>
                </video>
              </div>
            </div>
            <div class="col-2" *ngIf="sharePostArr.media_path ==''">
              <div class="postImg border">
                <img alt="loading..."    src="assets/images/news.png" class="img-fluid">
              </div>
            </div>
          </div>

          <div class="w-100">

            <textarea name="sharePostText" [maxlength]="totalMaxLength" (input)="urlifyPostOnlyLink($event)" [(ngModel)]="sharePostArr.sharePostText" #sharePostText="ngModel" rows="3" class="form-control news-textarea" placeholder="Write Something Here..."></textarea>

          </div>
        </div>
        <!-- remove post code from here and paste it on footer (s) -->
      </div>
    </div>
    <!-- team code (s) -->
    <div class="w-100">
      <div class="card mb-0">
        <ul class="followTabs list-unstyled d-flex justify-content-between align-items-center mb-0">
          <li class="flex-fill ">
            <a href="javascript:void(0);" placement="bottom" (click)="onClick(1)" [ngClass]="{'f-active': tab==='tab1'}">
              <span class="mdi mdi-soccer mdi-24px d-block"></span>
              <span class="d-none d-sm-block">All Leagues</span>
            </a>
          </li>

          
        </ul>
      </div>
    </div>

    <div class="card mb-0">
      <div class="card-body p-0">
        <span *ngIf="tab === 'tab1'">
          <div class="sticky">
            <div class="card">
              <h4 class="card-title d-block d-sm-none">
                <span class="lstick"></span> All Leagues
              </h4>
            </div>
          </div>

          <!-- Adding the Search box for Connection user(a) -->
          <div class="search shadow-sm sticky" style="top:0px;">
            <input type="text" class="form-control border-0" [(ngModel)]="searchSport" (keyup)="showLeaguesFollowSport()" placeholder="Search" />
            <span class="mdi mdi-magnify mdi-2x"></span>
          </div>
          <!-- End Adding the Search box for Connection user(a) -->
     
          <ul class="list-unstyled notMes" *ngIf="getContactNameArr.length > 0 && !primaryLoaderConatct">
            <li *ngFor="let user of getContactNameArr; let i = index">
              <div class="d-flex flex-row comment-row">
                <div class="p-2">
                  <img   *ngIf="user.profile_pic != ''" src="{{ user.profile_pic }}" class="img-fluid rounded-circle img-mh" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="50" />
                  <img    *ngIf="user.profile_pic == ''" src="{{ user_profile_img }}" class="img-fluid rounded-circle img-mh" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="50" />
                </div>
                <div class="comment-text w-100 pb-0">
                  <h5 class="mb-0">
                    <a href="javascript:void(0)">

                      <!-- adding the text with img popover(D) -->
                      <ng-template #popContent>
                        <div class="media">
                          <img    *ngIf="user.profile_pic != ''" src="{{ user.profile_pic }}" class="mr-3 img-fluid img-thumbnail" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="70" />
                          <img    *ngIf="user.profile_pic == ''" src="{{ user_profile_img }}" class="mr-3 img-fluid img-thumbnail" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="70" />
                          <div class="media-body">
                            <h6 class="media-heading mt-2 d-flex align-items-center">
                              <b class="truncate_bio">{{ user.name }}</b>
                              <span *ngIf="user.verified_badge == 1" class="{{badgeClass}} pl-1 text-info"></span>
                            </h6>
                          </div>
                        </div>
                      </ng-template>
                      <span class="d-inline-block text-truncate mw" [ngbPopover]="popContent" ngbPopover="" triggers="mouseenter:mouseleave">{{ user.name }} </span>
                      <span *ngIf="user.verified_badge == 1" class="{{badgeClass}} pl-1 text-info"></span>
                      <!-- End adding the text with img popover(D) -->
                    </a>
                    <!-- /////////////post button//////////// -->
                   
                    <span class="d-inline-flex float-right ml-2">
                      <a *ngIf="!clickedBtn" href="javascript:void(0);" (click)="CreatePostBtnFollowSports(sharePostArr,user,i);modalRef.hide()" class="btn btn-sm btn-info float-right ml-2">Post</a>
                      <a *ngIf="clickedBtn" href="javascript:void(0);" class="btn btn-sm btn-info float-right ml-2">Post</a>
                    </span>

                    

                    <span *ngIf="indexNo==i && lineLoader" class="d-inline-flex float-right">
                      <div id="fountainG" class="mr-5 mb-1">
                        <div id="fountainG_1" class="fountainG"></div>
                        <div id="fountainG_2" class="fountainG"></div>
                        <div id="fountainG_3" class="fountainG"></div>
                        <div id="fountainG_4" class="fountainG"></div>
                      </div>
                    </span>
                  </h5>
                  <small class="text-dark">{{ user.username }}</small>
                  <p class="mb-0 truncate_bio">{{ user.bio }}</p>
                </div>
              </div>
            </li>
            <li *ngIf="showMoreLoader">
              <div class="text-center">
                <div class="spinner-border text-info" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </li>
          </ul>
          <ul *ngIf="getContactNameArr.length == 0 && !primaryLoaderConatct" class="list-unstyled notMes">
            <li class="text-center">
              <h5>
                <strong>This user isn't following any sports yet.</strong>
              </h5>
              <p>Followed sports of this user can be viewed here.</p>
            </li>
          </ul>
          <div class="text-center" *ngIf="primaryLoaderConatct">
            <div class="spinner-border text-info" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
         
        </span>

        <span *ngIf="tab === 'tab2'">
          <div class="sticky">
            <div class="card">
              <h4 class="card-title d-block d-sm-none">
                <span class="lstick"></span> All Teams
              </h4>
            </div>
          </div>
          <div class="sticky bg-white py-2 mb-2" style="top:0px;">

            <!-- Adding the Search box for Connection user(a) -->
            <div class="search shadow-sm ">
              <input type="text" class="form-control border-0" [(ngModel)]="searchTeam" (keyup)="showTeamFollowSport()" placeholder="Search" />
              <span class="mdi mdi-magnify mdi-2x"></span>
            </div>
          </div>
          <!-- End Adding the Search box for Connection user(a) -->
      
          <ul class="list-unstyled notMes" *ngIf="getContactNameArr.length > 0 && !primaryLoaderConatct">
            <li *ngFor="let user of getContactNameArr; let i = index">
              <div class="d-flex flex-row comment-row">
                <div class="p-2">
                  <img    *ngIf="user.profile_pic != ''" src="{{ user.profile_pic }}" class="img-fluid rounded-circle img-mh" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="50" />
                  <img    *ngIf="user.profile_pic == ''" src="{{ user_profile_img }}" class="img-fluid rounded-circle img-mh" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="50" />
                </div>
                <div class="comment-text w-100 pb-0">
                  <h5 class="mb-0">
                    <a href="javascript:void(0)" (click)="searchUserNameClick(user)">

                      <!-- adding the text with img popover(D) -->
                      <ng-template #popContent>
                        <div class="media">
                          <img    *ngIf="user.profile_pic != ''" src="{{ user.profile_pic }}" class="mr-3 img-fluid img-thumbnail" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="70" />
                          <img    *ngIf="user.profile_pic == ''" src="{{ user_profile_img }}" class="mr-3 img-fluid img-thumbnail" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="70" />
                          <div class="media-body">
                            <h6 class="media-heading mt-2 d-flex align-items-center">
                              <b class="truncate_bio">{{ user.name }}</b>
                              <span *ngIf="user.verified_badge == 1" class="{{badgeClass}} pl-1 text-info"></span>
                            </h6>
                          </div>
                        </div>
                      </ng-template>
                      <span class="d-inline-block text-truncate mw" [ngbPopover]="popContent" ngbPopover="" triggers="mouseenter:mouseleave">{{ user.name }} </span>
                      <span *ngIf="user.verified_badge == 1" class="{{badgeClass}} pl-1 text-info"></span>
                      <!-- End adding the text with img popover(D) -->
                    </a>
                    <!-- /////////////post button//////////// -->
              
                    <span class="d-inline-flex float-right">
                      <a href="javascript:void(0);" (click)="CreatePostBtnFollowSports(sharePostArr,user,i);modalRef.hide()" class="btn btn-sm btn-info float-right ml-2">Post</a>
                    </span>
                    

                    <span *ngIf="indexNo==i && lineLoader" class="d-inline-flex float-right">
                      <div id="fountainG" class="mr-5 mb-1">
                        <div id="fountainG_1" class="fountainG"></div>
                        <div id="fountainG_2" class="fountainG"></div>
                        <div id="fountainG_3" class="fountainG"></div>
                        <div id="fountainG_4" class="fountainG"></div>
                      </div>
                    </span>
                  </h5>
                  <small class="text-dark">
                    <span class="truncate_bio_user">{{user.league_full_name}}</span>
                  </small>
                  <p class="mb-0">
                    <span class="label label-warning">{{user.league_name}}</span>
                  </p>
                </div>
              </div>
            </li>
            <li *ngIf="showMoreLoader">
              <div class="text-center">
                <div class="spinner-border text-info" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </li>
          </ul>
          <ul *ngIf="getContactNameArr.length == 0 && !primaryLoaderConatct" class="list-unstyled notMes">
            <li class="text-center">
              <h5>
                <strong>This user isn't following any teams yet.</strong>
              </h5>
              <p>Followed teams of this user can be viewed here.</p>
            </li>
          </ul>
          <div class="text-center" *ngIf="primaryLoaderConatct">
            <div class="spinner-border text-info" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="text-center position-relative" *ngIf="showMore && !primaryLoaderConatct">
            <a href="javascript:void(0);" (click)="showMoreTeams()" class="read-more" placement="top">
              <span class="mdi mdi-chevron-double-down">Show More</span>
            </a>
          </div>
        </span>

        <span *ngIf="tab === 'tab3'">
          <div class="sticky">
            <div class="card">
              <h4 class="card-title d-block d-sm-none">
                <span class="lstick"></span> All Players
              </h4>
            </div>
          </div>

          <div class="sticky bg-white py-2 mb-2" style="top:0px;">
            <!-- Adding the Search box for Connection user(a) -->
            <div class="search shadow-sm sticky" style="top:0px;">
              <input type="text" class="form-control border-0" [(ngModel)]="searchPlayer" (keyup)="showPlayerFollowSport()" placeholder="Search" />
              <span class="mdi mdi-magnify mdi-2x"></span>
            </div>

          </div>
          <!-- End Adding the Search box for Connection user(a) -->
          <ul class="list-unstyled notMes" *ngIf="getContactNameArr.length > 0 && !primaryLoaderConatct">
            <li *ngFor="let user of getContactNameArr; let i = index">
              <div class="d-flex flex-row comment-row">
                <div class="p-2">
                  <img    *ngIf="user.profile_pic != ''" src="{{ user.profile_pic }}" class="img-fluid rounded-circle img-mh" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="50" />
                  <img    *ngIf="user.profile_pic == ''" src="{{ user_profile_img }}" class="img-fluid rounded-circle img-mh" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="50" />
                </div>
                <div class="comment-text w-100 pb-0">
                  <h5 class="mb-0">
                    <a href="javascript:void(0)" (click)="searchUserNameClick(user)">

                      <!-- adding the text with img popover(D) -->
                      <ng-template #popContent>
                        <div class="media">
                          <img    *ngIf="user.profile_pic != ''" src="{{ user.profile_pic }}" class="mr-3 img-fluid img-thumbnail" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="70" />
                          <img    *ngIf="user.profile_pic == ''" src="{{ user_profile_img }}" class="mr-3 img-fluid img-thumbnail" onError="this.onerror=null; this.src='assets/images/default-image-sports.png';" alt="..." width="70" />
                          <div class="media-body">
                            <h6 class="media-heading mt-2 d-flex align-items-center">
                              <b class="truncate_bio">{{ user.name }}</b>
                              <span *ngIf="user.verified_badge == 1" class="{{badgeClass}} pl-1 text-info"></span>
                            </h6>
                          </div>
                        </div>
                      </ng-template>
                      <span class="d-inline-block text-truncate mw" [ngbPopover]="popContent" ngbPopover="" triggers="mouseenter:mouseleave">{{ user.name }} </span>
                      <span *ngIf="user.verified_badge == 1" class="{{badgeClass}} pl-1 text-info"></span>
                      <!-- End adding the text with img popover(D) -->
                    </a>
                    <!-- /////////////post button//////////// -->
                    
                    <span class="d-inline-flex float-right">
                      <a href="javascript:void(0);" (click)="CreatePostBtnFollowSports(sharePostArr,user,i);modalRef.hide()" class="btn btn-sm btn-info float-right ml-2">Post</a>
                    </span>
                   

                    <span *ngIf="indexNo==i && lineLoader" class="d-inline-flex float-right">
                      <div id="fountainG" class="mr-5 mb-1">
                        <div id="fountainG_1" class="fountainG"></div>
                        <div id="fountainG_2" class="fountainG"></div>
                        <div id="fountainG_3" class="fountainG"></div>
                        <div id="fountainG_4" class="fountainG"></div>
                      </div>
                    </span>
                  </h5>
                  <small class="text-dark">
                    <span class="truncate_bio_user">{{user.team_name}}</span>
                  </small>
                  <p class="mb-0">
                    <span class="label label-warning">{{user.league_name}}</span>
                  </p>
                </div>
              </div>
            </li>
            <li *ngIf="showMoreLoader">
              <div class="text-center">
                <div class="spinner-border text-info" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              </div>
            </li>
          </ul>
          <ul *ngIf="getContactNameArr.length == 0 && !primaryLoaderConatct" class="list-unstyled notMes">
            <li class="text-center">
              <h5>
                <strong>This user isn't following any players yet.</strong>
              </h5>
              <p>Following players of this user can be viewed here.</p>
            </li>
          </ul>
          <div class="text-center" *ngIf="primaryLoaderConatct">
            <div class="spinner-border text-info" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div class="text-center position-relative" *ngIf="showMore && !primaryLoaderConatct">
            <a href="javascript:void(0);" (click)="showMorePlayers()" class="read-more" placement="top">
              <span class="mdi mdi-chevron-double-down">Show More</span>
            </a>
          </div>
        </span>

      </div>
    </div>
  </div>
</ng-template>